import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent'
import { approveToken } from '../handlers/walletActions/wallet'
import { ICToken } from '../interfaces/common'
import { idlFactory as idlWaterNeuronFactory } from '../idls/waterNeuron/waterNeuronBackend.did'
import { _SERVICE as WaterNeuronFactory } from '../idls/waterNeuron/waterNeuronBackend.did'

const WATER_NEURON_BACKEND_CANISTER_ID = 'tsbvt-pyaaa-aaaar-qafva-cai'

const WTN_AIRDROP_TIERS = [
  { threshold: 80_000_000_000_00, rate: 8 },
  { threshold: 160_000_000_000_00, rate: 4 },
  { threshold: 320_000_000_000_00, rate: 2 },
  { threshold: 640_000_000_000_00, rate: 1 },
  { threshold: 1_280_000_000_000_00, rate: 0.5 },
  { threshold: 2_560_000_000_000_00, rate: 0.25 },
  { threshold: 5_120_000_000_000_00, rate: 0.125 },
]

export class WaterNeuron {
  private agent: HttpAgent
  private actor: ActorSubclass<WaterNeuronFactory>

  constructor(agent: HttpAgent) {
    this.agent = agent
    this.actor = Actor.createActor(idlWaterNeuronFactory, {
      canisterId: WATER_NEURON_BACKEND_CANISTER_ID,
      agent: this.agent,
    }) as ActorSubclass<WaterNeuronFactory>
  }

  computeRewards(alreadyDistributed: number, amount: number) {
    let totalRewards = 0
    let amountToDistribute = amount
    let cumulativeAmount = alreadyDistributed

    WTN_AIRDROP_TIERS.some(({ threshold, rate }) => {
      if (cumulativeAmount > threshold) {
        cumulativeAmount = cumulativeAmount - threshold
      } else {
        const tierAvailable = threshold - cumulativeAmount
        const amountInThisTier = Math.min(amountToDistribute, tierAvailable)

        cumulativeAmount = 0
        totalRewards = totalRewards + amountInThisTier * rate
        amountToDistribute = amountToDistribute - amountInThisTier

        return amountToDistribute === 0
      }
    })

    return totalRewards
  }

  async getInfo() {
    return this.actor.get_info()
  }

  async stake(amount: number, icpToken: ICToken) {
    await approveToken({
      standard: icpToken.standard,
      tokenCanisterId: icpToken.address,
      spender: {
        address: WATER_NEURON_BACKEND_CANISTER_ID,
      },
      amount: (amount + icpToken.fee!).toString(),
    })

    const result = await this.actor.icp_to_nicp({
      maybe_subaccount: [],
      amount_e8s: BigInt(amount),
    })

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }

  async unstake(amount: number, nicpToken: ICToken) {
    await approveToken({
      standard: nicpToken.standard,
      tokenCanisterId: nicpToken.address,
      spender: {
        address: WATER_NEURON_BACKEND_CANISTER_ID,
      },
      amount: (amount + nicpToken.fee!).toString(),
    })

    const result = await this.actor.nicp_to_icp({
      maybe_subaccount: [],
      amount_e8s: BigInt(amount),
    })

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }
}
